// extracted by mini-css-extract-plugin
export default {"button":"BackToTopButton_button__LYezx"};